import React from 'react';
import Table from 'Components/Table';
import useGetTenants from 'Hooks/query-hooks/tenants/useGetTenants';
import { useHistory } from 'react-router-dom';
import { useTemplateStore } from 'Hooks/zustand/useTemplateStore';
import { useAuthenticationStore } from 'Hooks/zustand/useAuthenticationStore';
import { useQueryClient } from '@tanstack/react-query';
import { EventNames, EventTypes, trackEvent } from '@brighterion/insights';
import { tenantsColumns } from './tenantsColumns';

import styles from './TenantsTable.css';

const TenantsTable = () => {
    const { impersonateTenant } = useAuthenticationStore();
    const { clearTemplate } = useTemplateStore();
    const history = useHistory();
    const { isLoading, data } = useGetTenants();
    const queryClient = useQueryClient();

    const impersonate = async (tenantKey: string) => {
        clearTemplate();
        await impersonateTenant(tenantKey);
        await queryClient.invalidateQueries();
        trackEvent({
            eventType: EventTypes.track,
            eventName: EventNames.click,
            payload: {
                clickIdentifier: 'Tenant - View Tenant Ruleset',
                text: `View Tenant Ruleset: ${tenantKey}`
            }
        });
        history.replace('/');
    };

    return (
        <div className={styles.tableContainer}>
            <Table
                tableName='tenants-table'
                showMultiSort
                showRichFilter
                pathToIdOnDataObj='tenant'
                enablePagination
                initialState={{
                    sortBy: [{ id: 'tenantName', desc: false }]
                }}
                dataTestId='tenants-table'
                noDataMessage='noTenantMsg'
                columns={tenantsColumns(impersonate)}
                data={data ?? []}
                showExpandableSearch
                isLoading={isLoading}
            />
        </div>
    );
};

export default TenantsTable;
